export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

type IntercomUser = {
  uid: string;
  email: string | null;
  displayName: string | null;
};

/**
 * Builds the Intercom boot payload for an authenticated user.
 * Sends the Firebase `uid` as Intercom's `userId` alongside the user's
 * email and name. Mirrors the identify pattern used for PostHog.
 */
export const getIntercomBootProps = (user: IntercomUser) => ({
  userId: user.uid,
  email: user.email ?? undefined,
  name: user.displayName ?? undefined,
});
